import React, {useEffect, useRef} from "react";

interface ClickOutsideProps extends React.HTMLAttributes<HTMLDivElement> {
    onClickOutside: () => void;
}

const ClickOutsideDetector: React.FC<ClickOutsideProps> = ({children, onClickOutside, ...restProps}) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickListener = (event: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                onClickOutside();
            }
        };

        document.addEventListener('mousedown', handleClickListener);

        return () => {
            document.removeEventListener('mousedown', handleClickListener);
        };
    }, [onClickOutside]);

    return (
        <div ref={wrapperRef} {...restProps}>
            {children}
        </div>
    );
}

export default ClickOutsideDetector;